import React, {useState, useEffect} from "react";
import {Grid} from "@mui/material";
import Box from "@mui/material/Box";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import ListAltIcon from "@mui/icons-material/ListAlt";
import HourglassEmptyRoundedIcon from "@mui/icons-material/HourglassEmptyRounded";
import axios from "axios";
import Button from "@mui/material/Button";
import {Link} from "react-router-dom";
import ApexCharts from 'apexcharts';
import Chart from 'react-apexcharts';
import chartData from "./Chart/Total6";
const Admin_Dashboard = () => {
    const [dashboard, setDashboard] = useState("");
    const [update, setUpdate] = useState(false);
    useEffect(() => {
        const data = {
            username: localStorage.getItem("username")
        }
        axios.post("https://app.zhivay.com/api/get_admin_dashboard.php", data)
            .then(response => {
                if (response.status === 200) {
                    setDashboard(response.data);
                } else {

                }

            })
            .catch(error => {

            })
    }, [update]);

    return (
        <div>

            <Grid
                container
                sx={{marginBottom: 3}}
                justifyContent="center"
                alignItems="center">
                <Grid item justifyContent="right" alignItems="right" xs={12} md={4} sm={6}>
                    <Box sx={{
                        minWidth: "200px",
                        backgroundColor: "#33588d",
                        margin: 2,
                        borderRadius: "7px"
                    }}>
                        <div>
                            <p
                                style={{
                                    color: "#FFFFFF",
                                    fontWeight: "bold",
                                    fontSize: "14px",
                                    textAlign:"right",
                                    padding:"10px",
                            }}>میزان فروش</p>
                            <span style={{color: "#FFFFFF"}}>{dashboard.todaygotprice}</span>
                        </div>
                    <Chart {...chartData} />
                    </Box>
                </Grid>
                <Grid item justifyContent="center" alignItems="center" xs={12} md={4} sm={6}>
                    <Box sx={{
                        minWidth: "200px",
                        backgroundColor: "#0d47a1",
                        padding: 1,
                        margin: 2,
                        borderRadius: "7px"
                    }}>
                        <Grid container spacing={2} sx={{marginTop: 2, width: "100%"}}>
                            <Grid xs={6}>
                                <div style={{textAlign: "left"}}>
                                    <MonetizationOnIcon sx={{fontSize: 92, color: "#4575bb", marginLeft: 2}}/>
                                </div>
                            </Grid>
                            <Grid xs={6} sx={{textAlign: "right"}}>
                                <div>
                                    <p style={{color: "#FFFFFF", fontWeight: "bold", fontSize: "14px"}}>پرداختی های
                                        امروز</p>
                                    <span style={{color: "#FFFFFF"}}>{dashboard.todaygotprice}</span>
                                </div>
                            </Grid>
                        </Grid>
                        <div>
                            <Button
                                sx={{color: "#ffffff", fontSize: "12px"}}
                                variant="outlined"
                                fullWidth
                                color="primary"
                                size="small"
                            >[ نمایش ]</Button>
                        </div>
                    </Box>
                </Grid>
                <Grid item justifyContent="center" alignItems="center" xs={12} md={4} sm={6}>
                    <Box sx={{
                        minWidth: "200px",
                        backgroundColor: "#e53935",
                        padding: 1,
                        margin: 2,
                        borderRadius: "7px"
                    }}>
                        <Grid container spacing={2} sx={{marginTop: 2, width: "100%"}}>
                            <Grid xs={6}>
                                <div style={{textAlign: "left"}}>
                                    <ListAltIcon sx={{fontSize: 92, color: "#e06d6b", marginLeft: 2}}/>
                                </div>
                            </Grid>
                            <Grid xs={6} sx={{textAlign: "right"}}>
                                <div>
                                    <p style={{color: "#FFFFFF", fontWeight: "bold", fontSize: "14px"}}>فاکتور های
                                        امروز</p>
                                    <span style={{color: "#FFFFFF"}}>{dashboard.todayfactor}</span>
                                </div>
                            </Grid>
                        </Grid>
                        <div>
                            <Button
                                sx={{color: "#ffffff", fontSize: "12px"}}
                                variant="outlined"
                                fullWidth
                                color="primary"
                                size="small"
                            >[ نمایش ]</Button>
                        </div>
                    </Box>
                </Grid>
                <Grid item justifyContent="center" alignItems="center" xs={12} md={4} sm={6}>
                    <Box sx={{
                        minWidth: "200px",
                        backgroundColor: "#f9a825",
                        padding: 1,
                        margin: 2,
                        borderRadius: "7px"
                    }}>
                        <Grid container spacing={2} sx={{marginTop: 2, width: "100%"}}>
                            <Grid xs={6}>
                                <div style={{textAlign: "left"}}>
                                    <HourglassEmptyRoundedIcon sx={{fontSize: 92, color: "#fabc5b",marginLeft:2}}/>
                                </div>
                            </Grid>
                            <Grid xs={6} sx={{textAlign: "right"}}>
                                <div>
                                    <p style={{color: "#FFFFFF", fontWeight: "bold", fontSize: "14px"}}>سفارشات آماده
                                        نشده</p>
                                    <span style={{color: "#FFFFFF"}}>{dashboard.notcomplateorder}</span>
                                </div>
                            </Grid>
                        </Grid>
                        <div>
                            <Link to="/orders">
                                <Button
                                    sx={{color: "#ffffff", fontSize: "12px"}}
                                    variant="outlined"
                                    fullWidth
                                    color="primary"
                                    size="small"
                                >[ نمایش ]</Button>
                            </Link>
                        </div>
                    </Box>
                </Grid>
            </Grid>
        </div>
    )
}
export default Admin_Dashboard;